<template>
    <rkm-modal
        :loading="loading"
        large
        ref="RkmModal"
        title="Novo responsável familiar "
        v-if="data.form"
    >

    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-col cols="12" v-if="item">
            <strong>{{ item.nome }}</strong> deixará de ser considerado o responsável familiar,
            sendo necessário indicar outro membro da família para assumir essa responsabilidade.
        </rkm-col>

        <rkm-col cols="12" class="mt-3">
            <rkm-form-select
                :options="residentes"
                label="Novo responsável familiar"
                show-default-option
                text-field="nome"
                v-model="data.model.responsavelCidadaoId"
                default-option-text="Selecione"
                value-field="id"
                :validations="validations.responsavelFamiliar"
            />
        </rkm-col>
    </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="handleCancel()">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="handleRegister()"
                color="primary"
            >
                Registrar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                responsavelFamiliar: { required: true },
            }
        },
        residentes() {

            return this.item && this.data.form.residentes && this.data.form.residentes.length > 0
                ? this.data.form.residentes.filter(item => item.pacienteId != this.item.pacienteId) : []
        }
    },
    data: () => ({
        loading: false,
        model: {},
        item: null,
    }),
    methods: {
        async validate() {

            return this.$refs.RkmModal.validate()
        },
        open(item) {
            this.item = item
            this.$refs.RkmModal.show()
        },
        handleCancel() {

            this.$refs.RkmModal.hide()
        },
        handleRegister() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                if (this.data.model.responsavelCidadaoId == this.data.model.cidadao.id) {

                    this.data.model.responsavel = true
                    this.data.model.responsavelCidadaoId = null
                } else {

                    this.data.model.responsavel = false

                    if (this.data.form.responsaveis.length == 0) {

                        const responsavel = this.data.form.residentes.find(responsavel =>
                            responsavel.id == this.data.model.responsavelCidadaoId)

                        this.data.form.responsaveis.push(responsavel)
                    }
                }

                this.$emit('remove', this.item)

                this.$refs.RkmModal.hide()
            })
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>